import React from 'react';

export const GradientLine = () => (
    <svg
        width="1260"
        height="2"
        viewBox="0 0 1260 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M0 1H1260" stroke="url(#paint0_linear_2413_20490)" />
        <defs>
            <linearGradient
                id="paint0_linear_2413_20490"
                x1="0"
                y1="1.5"
                x2="1260"
                y2="1.49987"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#EAEAEA" stopOpacity="0.1" />
                <stop
                    offset="0.511666"
                    stopColor="#BCBCBC"
                    stopOpacity="0.543334"
                />
                <stop offset="1" stopColor="#EAEAEA" stopOpacity="0.1" />
            </linearGradient>
        </defs>
    </svg>
);
